<div class="w-100">
   <div class="outage-message-holder  text-center  p-3" *ngIf='isActive'>
      <i class="fas fa-exclamation-square pr-2"></i> {{information}}</div>
</div>
